import { render, staticRenderFns } from "./Fans.vue?vue&type=template&id=7b12ef1c&scoped=true&"
import script from "./Fans.vue?vue&type=script&lang=js&"
export * from "./Fans.vue?vue&type=script&lang=js&"
import style0 from "./Fans.vue?vue&type=style&index=0&id=7b12ef1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12ef1c",
  null
  
)

export default component.exports